export const STATUS_TYPES = {
    LOADED: 'LOADED',
    PENDING: 'PENDING',
    INITIAL: 'INITIAL',
    FAILED: 'FAILED'
};

export default STATUS_TYPES;